import { Selector } from '@ngxs/store';
import _ from 'lodash';
import { QueueSelectionPurpose } from 'src/app/samwebDescription/samwin/QueueSelectionPurpose';
import { SamwinCallInfoRemoteDto } from 'src/generated/signalR/samwin-call-info-remote-dto';
import { SamwinMessageInfoRemoteDto } from 'src/generated/signalR/samwin-message-info-remote-dto';
import { QueueShortInfoRemoteDto } from 'src/generated/swagger';
import { SamwinCallListState } from '../samwin-call-list/samwin-call-list.state';
import { SamwinMessageListState } from '../samwin-mail-list/samwin-message-list.state';
import { QueueSelectionDialogState, QueueSelectionDialogStateModel } from './queue-selection-dialog.state';

export class QueueSelectionDialogSelectors {
   @Selector([QueueSelectionDialogState])
   public static getPurpose(state: QueueSelectionDialogStateModel): QueueSelectionPurpose {
      return state.purpose;
   }

   @Selector([QueueSelectionDialogState])
   public static getQueueContextData(state: QueueSelectionDialogStateModel): any {
      return state.contextData;
   }

   @Selector([QueueSelectionDialogState])
   public static getSelectedQueue(state: QueueSelectionDialogStateModel): QueueShortInfoRemoteDto {
      return state.selectedQueue;
   }

   @Selector([QueueSelectionDialogState])
   public static getFilteredSelectableQueues(state: QueueSelectionDialogStateModel): QueueShortInfoRemoteDto[] {
      return _(state.selectableQueues)
         .filter((queue) => {
            return _.isEmpty(state.searchText) || state.searchText.split(' ').every((criterion) => queue.name.toLowerCase().includes(criterion.toLowerCase()));
         })
         .orderBy((queue) => queue.name.toLowerCase(), 'asc')
         .value();
   }

   @Selector([QueueSelectionDialogState, SamwinCallListState.getCallList, SamwinMessageListState.waitList])
   public static isQueueSelectionInProgress(
      state: QueueSelectionDialogStateModel,
      callList: SamwinCallInfoRemoteDto[],
      messageList: SamwinMessageInfoRemoteDto[]
   ): boolean {
      const hasPurpose = !_.isNil(state.purpose);
      const requiresCall = state.purpose?.requireCall ?? false;
      const isInCallList = callList.some((item) => item.callId === state.contextData?.callId);
      const isInMessageList = messageList.some((item) => item.callId === state.contextData?.callId);

      return hasPurpose && (!requiresCall || isInCallList || isInMessageList);
   }

   @Selector([QueueSelectionDialogState])
   public static isQueueSelected(state: QueueSelectionDialogStateModel): boolean {
      return !_.isNil(state?.selectedQueue);
   }

   @Selector([QueueSelectionDialogState])
   public static isLoadingSelectableQueues(state: QueueSelectionDialogStateModel): boolean {
      return _.isNil(state?.selectableQueues);
   }
}
